import React from "react";
import { Map } from "lucide-react";

export default function ExploreOpenMapButton({ onOpen }) {
  return (
    <div className="p2-explore-open-map">
      <button
        type="button"
        onClick={onOpen}
        className="p2-open-map-btn"
      >
        <span className="p2-open-map-btn-icon">
          <Map className="p2-open-map-btn-icon-svg" />
        </span>
        Hap pamjen me hartë
      </button>
    </div>
  );
}
